import React from "react"

const UploadedFileBox = ({ label, href }) => {
  return (
    <>
      <p
        className="mb-0 mt-2 px-2 py-2 d-flex justify-content-between align-items-center"
        style={{
          background: "#f7f7f7",
          border: "2px dashed #dcdcdc",
          borderRadius: "10px",
        }}
      >
        {label}{" "}
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          style={{
            fontSize: "13px",
          }}
        >
          View
        </a>
      </p>
    </>
  )
}

export default UploadedFileBox
